export default {
  namespaced: true,

  state: {
    data: {},
    activeModal: false
  },

  getters: {
    /**
     * Safely get data by the given key from the store
     *
     * @param  {Object} state
     * @return {*|null}
     */
    get: (state) => (key) => {
      if (state.data[key]) {
        return state.data[key];
      }

      return null;
    },

    getActive: (state) => () => {
      return state.activeModal;
    },

    getData: state => state.data
  },

  mutations: {
    setActive (state, modal) {
      state.activeModal = modal;
    },

    setData (state, data = {}) {
      state.data = data;
    },

    put (state, {key, value}) {
      state.data[key] = value;
    },

    merge (state, data = {}) {
      Object.assign(state.data, data);
    }
  },

  actions: {
    setActive ({commit}, modal) {
      commit('setActive', modal);
    },

    setData ({commit}, data) {
      commit('setData', data);
    },

    put ({commit}, data) {
      commit('put', data);
    },

    merge ({commit}, data) {
      commit('merge', data);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/components/store/modules/modal.js